module.exports = __webpack_public_path__ + "static/media/ic_finish_sign_up.fe14e8f1.svg";